import { faTimes } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AdZone } from 'adcontrolx-lib'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import * as SETTINGS from '../../../constants/settings'
import { SiteConfigContext } from '../../../context/siteConfigContext'
import { appendStoredQueryParams } from '../../../utils/utilities'
import Countdown from '../Countdown'
import TextWrapper from '../TextWrapper'
import './AdBanners.css'

const AdBannerDesktop = ({ handleDismiss }) => {
  const { [SETTINGS.BANNER_DATA.key]: bannerData, kevelIds } =
    useContext(SiteConfigContext)

  if (!bannerData || !kevelIds) return null

  const handleDismissAd = () => {
    handleDismiss()
  }

  const handleOpenLink = () => {
    const linkWParams = appendStoredQueryParams(bannerData.promoLink)
    window.open(linkWParams, '_blank')
  }

  if (bannerData.useKevelAdZone) {
    return (
      <div className="relative">
        {bannerData.allowClose && (
          <button
            onClick={handleDismissAd}
            className="button-x"
            disabled={location.pathname.includes('ad-builder')}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        )}
        <div className="adcontrolx_header_zone">
          <AdZone
            zoneId={kevelIds?.zoneIds?.banner?.id || ''}
            adType={kevelIds?.zoneIds?.banner?.type || ''}
          />
        </div>
      </div>
    )
  }

  const bgColor = bannerData.bgColor
    ? `bg-${bannerData.bgColor}-400 border-${bannerData.bgColor}-500`
    : 'bg-yellow-400 border-yellow-500'
  const buttonColor = bannerData.buttonColor
    ? `bg-${bannerData.buttonColor}-500 border-${bannerData.buttonColor}-600`
    : 'bg-green-500 border-green-600'
  const showToggle = handleDismiss && bannerData.showCountdown

  return (
    <div className="AdBanners relative">
      {bannerData.allowClose && (
        <button onClick={handleDismissAd} className="button-x">
          <FontAwesomeIcon icon={faTimes} />
        </button>
      )}
      <div
        className={`${bgColor} flex flex-col p-2 justify-center items-center md:rounded-xl shadow-md border text-sm md:text-base`}
      >
        {showToggle && (
          <div className="mx-auto">
            <span className="flex items-center text-center font-bold italic text-xs md:text-sm gap-1">
              {bannerData.countdownText}
              <Countdown
                endDate={bannerData.endDateTime}
                endEvent={handleDismissAd}
              />
            </span>
          </div>
        )}
        <div
          className="flex flex-col items-center justify-center w-full gap-1 px-4 cursor-pointer"
          onClick={handleOpenLink}
        >
          <div className="text-black text-base md:text-lg w-fit text-center">
            <TextWrapper renderLinks={true} text={bannerData.body} />
          </div>
          {bannerData.showButton && (
            <button
              className={`${buttonColor} border rounded px-2 py-1 font-bold whitespace-nowrap transition-all duration-300 hover:shadow-button hover:scale-[1.05] text-black`}
            >
              {bannerData.buttonText}
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

AdBannerDesktop.propTypes = {
  handleDismiss: PropTypes.func
}

export default AdBannerDesktop
